import React from 'react';
import Pending from '../../../../../assets/common/Pending';
import Fees from '../../../../../assets/common/Fees';
import Dollar from '../../../../../assets/common/Dollar';

const PaymentMethodInfo = ({ paymentMethod }) => {
    const infoCards = [
        { title: 'Transaction Fees', value: paymentMethod?.fees, suffix: '%', color: "bg-[#E9E7FD]", icon: <Fees color="#7367F0" /> },
        { title: 'Processing Time', value: paymentMethod?.processingTime, color: 'bg-[#D6F4F8]', icon: <Pending color="#00BAD1" /> },
        { title: 'Minimum Deposit', value: paymentMethod?.minAmount, prefix: '$', color: 'bg-[#FFF0E1]', icon: <Dollar color="#FF9F43" /> },
        { title: 'Maximum Deposit', value: paymentMethod?.maxAmount, prefix: '$', color: 'bg-[#DDF6E8]', icon: <Dollar color="#28C76F" /> },
    ];

    return (
        <div className='border-2 border-light rounded-lg p-5'>
            <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-5">
                {infoCards?.map((card) => (
                    <div className='flex items-center gap-3'>
                        <div className={`flex justify-center items-center ${card?.color} w-[45px] h-[45px] rounded-lg`}>
                            {card?.icon}
                        </div>
                        <div>
                            <p className='sm:text-xl text-md'>{card?.prefix} {card?.value || 0} {card?.suffix}</p>
                            <p className='text-sm font-medium text-gray-500 capitalize'>{card?.title}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default PaymentMethodInfo